import React from "react";

type Feature = {
  name: string;
  description: string;
  disclosure?: string;
  icon: any;
};

type Props = {
  title?: string;
  description?: string;
  features: Feature[];
};

export const FeatureGridWithIconsTwoColumns = ({
  title,
  description,
  features,
}: Props) => {
  return (
    <div className="bg-gray-50 py-4">
      <div className="mx-auto px-8 text-center max-w-2xl md:max-w-3xl lg:max-w-5xl xl:max-w-7xl">
        {title && (
          <h2 className="mt-2 text-3xl font-bold text-blue-500">{title}</h2>
        )}
        {description && (
          <p className="mt-5 max-w-prose mx-auto text-xl text-gray-700">
            {description}
          </p>
        )}
        <div className="mt-10">
          <div className="grid grid-cols-1 gap-x-4 gap-y-8 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 ">
            {features.map((feature, index) => (
              <div
                key={index}
                className="rounded-md px-3 border border-gray-100 shadow-md"
              >
                <div className="">
                  <div>
                    <div className="inline-flex items-center justify-center p-4 rounded-lg">
                      <feature.icon className="h-9 w-9 text-blue-300" />
                    </div>
                  </div>
                  <h3 className="mt-2 text-lg font-bold text-blue-500 ">
                    {feature.name}
                  </h3>
                  <p className="mt-2 text-base text-gray-700 flex-1">
                    {feature.description}
                  </p>
                  <p className="mt-5 text-sm text-gray-700 flex-1">
                    <i>{feature.disclosure}</i>
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
